import {Badge} from "@/lib/components/Badge";
import * as React from "react";
import {useAppTheme} from "@/app/AppThemeContext";
import {GroupBox} from "@/lib/components/GroupBox";
import {CompanyMembershipStatus} from "@/api/data-contracts";
import {useTranslation} from "react-i18next";
import { CommonI18N } from "@/translations";
import {color_green, color_grey} from "@/agentur/AgenturColors";

function getUserStatusText(t: (key: string) => string, status: CompanyMembershipStatus) {
    return status && t(CommonI18N.enum.companyMembershipStatus[status]);
}

function getUserStatusColor(mode: string, status: CompanyMembershipStatus) {
    switch (status) {
        case CompanyMembershipStatus.INVITED:
            return color_grey[4];
        case CompanyMembershipStatus.INVITED_LOCKED:
            return color_grey[4];
        case CompanyMembershipStatus.CONFIRMED:
            return color_green[1];
        case CompanyMembershipStatus.CONFIRMED_LOCKED:
            return color_green[3];
        case CompanyMembershipStatus.DEACTIVATED:
            return color_grey[3];
    }
}

export const UserStatusBadge = ({ status, fullWidth }: { status?: CompanyMembershipStatus; fullWidth?: boolean }) => {
    const theme = useAppTheme();
    const { t } = useTranslation();
    return (
        status && (
            <Badge
                label={getUserStatusText(t, status)}
                backgroundColor={getUserStatusColor(theme.mode, status)}
                fullWidth={fullWidth}
            />
        )
    );
};

export const UserStatusBadgeField = ({ status }: { status: CompanyMembershipStatus }) => {
    const { t } = useTranslation();
    return (
        <GroupBox title={t(CommonI18N.field.status)} paddingTop={9} paddingBottom={9}>
            <UserStatusBadge status={status} fullWidth />
        </GroupBox>
    );
};
